<template>
  <div class="userMain">
    <!-- 搜索框  :pagePermit="pagePermit"-->
    <SearchBar
      @search="fetchData"
      :parentArray="parentArray"
      @opentitleForm="handleAddBtn"
      @openTree="handleTreeBtn"
      :list="list"
    />
    <el-table
      :data="list"
      style="width: 100%"
      row-key="menuId"
      border
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="name" label="名称" width="200px">
      </el-table-column>
      <el-table-column label="图标" align="center">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="地址" align="center">
      </el-table-column>
      <el-table-column prop="menuDesc" label="描述" align="center">
      </el-table-column>
      <el-table-column prop="sortNum" label="排序号" align="center" sortable>
      </el-table-column>
      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="text"
            @click="handleEditBtn(scope.row)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >

          <!-- v-if="pagePermit.includes('_Delete')" v-if="pagePermit.includes('_Update')" -->
          <el-button
            size="small"
            type="text"
            @click="handleDeleteBtn(scope.row)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定删除该用户吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMenu()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看用户角色 -->
    <permit-tree
      ref="treeRef"
      :loadData="treeData"
      :defaultCheckedNodes="defaultCheckedNodes"
      :menuObj="menuObj"
    />
    <!-- 添加表单 -->
    <AddForm ref="addFormRef" :editData="editData" :options="options" />
    <!-- 分页 -->
    <!-- <Pagination ref="Pagination" /> -->
  </div>
</template>

<script>
import { getMenuApi, delMenuApi, getMenuPermitApi } from '@/api/user.js';
import SearchBar from './components/searchBar'; // 搜索框
// import Pagination from "@/components/Pagination";
import AddForm from './components/addForm'; //添加表单
import PermitTree from './components/permitTree'; //查看角色
import { mapGetters } from 'vuex';
export default {
  name: 'Message',
  components: {
    SearchBar,
    // Pagination,
    AddForm,
    PermitTree,
  },
  data() {
    return {
      list: [],
      roleData: [],
      listLoading: false,
      status: 0,
      parentArray: [],
      dialogVisible: false,
      deleteRow: '',
      isFirst: true,
      password: '',
      resetDialog: false,
      editData: false,
      options: [],
      treeData: [],
      defaultCheckedNodes: [],
      menuObj: {},
      path: '',
    };
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.fetchData();
  },
  inject: ['reload'],
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  watch: {
    paginObj: 'fetchData',
  },
  methods: {
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData(obj = {}) {
      this.parentArray = [];
      try {
        this.listLoading = true;
        let res = await getMenuApi({
          ...obj,
        });
        if (res.code !== 200) return;
        this.listLoading = false;
        this.options = res.data;
        const arrayData = res.data.map((item) => {
          if (item.parentMenuId != '') {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].menuId == item.parentMenuId) {
                if (!res.data[i].children) res.data[i].children = [];
                res.data[i].children.push(item);
                item.flag = 1;
              }
            }
          }
          return item;
        });
        const data = arrayData.filter((item) => !item.flag);
        this.list = data;
        data.forEach((item) => {
          if (item.children) {
            this.parentArray.push({
              label: item.name,
              value: item.menuId,
            });
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    handleAddBtn() {
      this.editData = false;
      this.$refs.addFormRef.dialogAddVisible = true;
    },

    // 编辑按钮处理
    handleEditBtn(row) {
      this.editData = true;
      this.$refs.addFormRef.fileList = [{ url: row.icon }];
      this.$refs.addFormRef.form = { ...row };
      this.$refs.addFormRef.icon = row.icon.substr(37);
      this.$refs.addFormRef.dialogAddVisible = true;
    },

    // 菜单权限
    async handleTreeBtn() {
      const res = await getMenuPermitApi();
      this.defaultCheckedNodes = [];
      this.menuObj = {};
      let array = this.filterData(res.data);
      this.treeData = array;
      this.$refs.treeRef.treeDialog = true;
    },
    filterData(array) {
      let data = array.map((item) => {
        this.menuObj[item.menu.menuId] = [];
        return {
          name: item.menu.name,
          sortNum: item.menu.sortNum,
          superId: item.menu.superId,
          menuId: item.menu.menuId,
          childs: item.permits
            ? item.permits.map((child) => {
                child.id = item.menu.menuId + child.permitId; //设置唯一id
                child.menuId = item.menu.menuId;
                if (child.select === 1) {
                  this.defaultCheckedNodes.push(child.id); //为1表示勾选
                }
                return child;
              })
            : [],
        };
      });
      let arr = data
        .map((item) => {
          for (let i = 0; i < data.length; i++) {
            // console.log(item.superId,data[i].menuId)
            if (item.superId == data[i].menuId) {
              //item找到其父节点
              data[i].childs.push(item);
              item.flag = 1;
            }
          }
          return item;
        })
        .filter((item) => !item.flag)
        .sort((a, b) => {
          return a.sortNum - b.sortNum;
        });

      return arr;
    },

    handleDeleteBtn(row) {
      this.dialogVisible = true;
      this.deleteRow = row;
    },

    // 删除菜单
    async deleteMenu() {
      const row = this.deleteRow;
      this.listLoading = true;
      const data = `menuId=${row.menuId}`;
      try {
        await delMenuApi(data).then((res) => {
          this.listLoading = false;
          this.dialogVisible = false;
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.reload();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cell {
  display: flex;
}
</style>
